import React, { useState, useEffect, useCallback, createContext, useContext } from 'react';
import apiService from '../services/apiService';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const checkUser = useCallback(async () => {
        console.log("Checking user auth status...");
        try {
            const currentUser = await apiService.fetchUser();
            console.log("Current user from API:", currentUser);
            setUser(currentUser);
        } catch (e) {
            console.error("Error fetching user:", e);
            setUser(null);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        checkUser();
    }, [checkUser]);

    // This function will be used by the logout button
    const logout = useCallback(async () => {
        try {
            await apiService.logout();
            setUser(null); 
        } catch (error) {
            console.error("Logout failed:", error);
            // Force client-side logout even if API fails
            setUser(null);
        }
    }, []);

    const value = { user, setUser, isLoading, refetchUser: checkUser, logout };

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
    return useContext(AuthContext);
};
